import './App.css';
// import logo from "../public/images/logo.svg";
import { MdArrowOutward } from "react-icons/md";
import { FiDownload } from "react-icons/fi";
import { useEffect, useRef, useState } from 'react';
import Slider from "react-slick";
import Admission from './components/Admission';
import WhyChooseArya from './components/WhyChooseArya ';
import GrowthSection from './components/GrowthSection';
import UndergraduatePrograms from './components/UndergraduatePrograms';
import PrideExcellence from './components/PrideExcellence';
import IndustrialAlliances from './components/IndustrialAlliances ';
import Footer from './components/Footer';
import { RiCustomerService2Line } from 'react-icons/ri';

function App() {



  const bainer_slider = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 6000,
    rtl: false,
    cssEase: "linear",
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 0
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  };
  const bainer_slider1 = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 6000,
    rtl: true,
    cssEase: "linear",
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 0
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  };


  // const toppersSlider = {
  //   infinite: true,
  //   slidesToShow: 6,
  //   slidesToScroll: 6,
  //   rows: 1,
  //   slidesPerRow: 1,
  //   responsive: [
  //     {
  //       breakpoint: 1400,
  //       settings: {
  //         slidesToShow: 5,
  //         slidesToScroll: 5,
  //         infinite: true
  //       }
  //     },
  //     {
  //       breakpoint: 992,
  //       settings: {
  //         slidesToShow: 4,
  //         slidesToScroll: 4
  //       }
  //     },
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 2
  //       }
  //     },
  //     {
  //       breakpoint: 576,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1
  //       }
  //     }
  //   ]
  // };



  const [showModal, setShowModal] = useState(false);
  const [formHeading, setFormHeading] = useState(""); // 🔹 heading state
  const modalRef = useRef();

  const openModal = (headingText) => {
    setFormHeading(headingText); //  set heading dynamically
    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);

  // Close modal when clicked outside
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal();
      }
    };

    if (showModal) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [showModal]);
  const [hideCTA, setHideCTA] = useState(false);
  const formRef = useRef(null);

  useEffect(() => {
    const currentForm = formRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHideCTA(true);
        } else {
          setHideCTA(false);
        }
      },
      { threshold: 0.2 }
    );

    if (currentForm) {
      observer.observe(currentForm);
    }

    return () => {
      if (currentForm) {
        observer.unobserve(currentForm);
      }
    };
  }, []);

  return (
    <>
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-container slide-down" ref={modalRef}>
            <div className="modal-body form_container position-relative">
              <Admission heading={formHeading} onClose={closeModal} />
            </div>
          </div>
        </div>
      )}

      <div className={`admission_cta d-md-none d-block ${hideCTA ? "d-none" : ""}`}>
        <div className="adm_text text-center mb-3">
          Admission Open  <span className='fw-bold' style={{ color: '#E31E24' }}>2026-27</span>
        </div>
        <div className='text-center px-3'>
          <button className="" style={{
            marginTop: "20px",
            background: "#e11b22",
            color: "#fff",
            padding: "12px 22px",
            borderRadius: "10px",
            border: "none",
            fontSize: "14px",
            gap: "8px",
          }} onClick={() => openModal("Apply Now")}>Apply Now <MdArrowOutward className="ms-1 fw-bold" /></button>
          <a href="tel:09001992258" style={{ textDecoration: 'none' }}>
            <button className="ms-3" style={{
              marginTop: "20px",
              background: "#3c3c3c",
              color: "#fff",
              padding: "12px 22px",
              borderRadius: "10px",
              border: "none",
              fontSize: "14px",
              gap: "8px",
            }}>
              Call Now <RiCustomerService2Line className="ms-1 fw-bold" />
            </button>
          </a>
        </div>
      </div>
      <header className="container-fluid px-0 h-100">
        <div className="container">
          <nav className='d-flex justify-content-center justify-content-md-between py-3'>
            <div> <a className="navbar-brand" href="/"><img src="/images/logo.webp" alt="Logo" width="250" /></a></div>
            <div className='d-none d-md-block'>

              <img src="/images/institution_logo.svg" alt="institution logo" width="120" style={{ paddingRight: "20px" }} />
              <img src="/images/nba_logo.svg" alt="nba logo" style={{ paddingRight: "20px" }} />
              <img src="/images/a_rank_logo.svg" alt="a rank logo" style={{ paddingRight: "25px", borderRight: '1px solid #E5B2B9' }} height={'35px'} />


              <button className="rounded-pill text-light border-0" onClick={() => openModal("Apply Now")} style={{ background: '#E31E24', padding: '10.27px 11.55px', lineHeight: '1.3', marginLeft: '25px' }}><FiDownload className="ms-1 fw-bold " />  Brochure </button>
            </div>
          </nav>
        </div>
      </header>
      {/* Banner section  */}
      <div className="container-fluid px-0 bainer_slider_section">
        <div className="bainer_slider_layout">
          <div className="container d-flex align-items-center h-100">
            <div className="w-100">
              <div className="row">
                <div className="col-lg-5 ">
                  <div className=''>
                    {/* <div className='banner_title'>Admissions Open for <span>2026-27</span></div> */}
                    <h1 className='banner_heading mb-0'>Shape Your Future
                      <br /> Join
                      <span className='color_heading'> Arya College</span></h1>
                    {/* Join Arya College – One of the Best B.Tech College in Jaipur for 2025-26 Admissions */}
                    <p className='banner_par mt-3 mb-0'>Top-notch education, real-world application, and global opportunities to shape your dream career.
                      {/* <br className='d-md-none b-block' /> to  shape your dream career */}
                    </p>
                    <span className='fw-bold btech_text' style={{ color: '#E31E24' }}>B.Tech</span>
                    <div className='package-container'>


                      <div className="row">
                        <div className="col-4" style={{ borderRight: '1px solid #780002' }}>
                          <p className='mb-0 av_package' style={{ color: '#B10507' }}>6 <br /> </p>
                          <p className='fs-6 mb-0 text-center' style={{ color: "#B10507", fontWeight: "400", lineHeight: "97%" }}>LPA</p>
                          <p className='mb-0 mt-1 av_package_para'>Average
                          </p>
                        </div>
                        <div className="col-4" style={{ borderRight: '1px solid #780002' }}>
                          <p className='mb-0 av_package' style={{ color: '#B10507' }}>22 <br /> </p>
                          <p className='fs-6 mb-0 text-center' style={{ color: "#B10507", fontWeight: "400", lineHeight: "97%" }}>LPA</p>
                          <p className='mb-0 mt-1 av_package_para'>Highest
                          </p>
                        </div>
                        <div className="col-4">
                          <p className='mb-0 av_package' style={{ color: '#B10507' }}>8 <br /> </p>
                          <p className='fs-6 mb-0 text-center' style={{ color: "#B10507", fontWeight: "400", lineHeight: "97%" }}>LPA</p>
                          <p className='mb-0 mt-1 av_package_para'>Median
                          </p>
                        </div>
                      </div>


                      {/* <div className="d-flex align-items-center justify-content-between ">
                        <div className='px-lg-5 px-3' style={{ borderRight: '1px solid #780002' }}>
                          <p className='mb-0 av_package' style={{ color: '#B10507' }}>15.3 <br /> </p>
                          <p className='fs-6 mb-0 text-center' style={{ color: "#B10507", fontWeight: "400", lineHeight: "97%" }}>LPA</p>
                          <p className='mb-0 mt-1 av_package_para'>Average
                          </p>
                        </div>
                        <div className='px-lg-5 px-3' style={{
                          borderRight: "0.75px solid",
                          borderImage: "linear-gradient(180deg, #666666, #B40103, #666666) 1"
                        }}>
                          <p className='mb-0 hig_package' >30 <br /></p>
                          <p className='fs-6 mb-0 text-center' style={{ color: "#B10507", fontWeight: "400", lineHeight: "97%" }}>LPA</p>
                          <p className='mb-0 mt-1 av_package_para'>Highest
                          </p>
                        </div>
                        <div className='px-lg-5 px-3'>
                          <p className='mb-0 av_package'>15 <br /></p>
                          <p className='fs-6 mb-0 text-center' style={{ color: "#B10507", fontWeight: "400", lineHeight: "97%" }}>LPA</p>
                          <p className='mb-0 mt-1 av_package_para'>Median
                          </p>
                        </div>
                      </div> */}

                      <p className='text-center mb-0' style={{ marginTop: "12px", fontSize: "10px", lineHeight: "11.5px" }}>*Packages 2025 Placements</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 "></div>
                <div className="col-lg-4 ">
                  <div className='form_parent d-lg-block d-none'>
                    <Admission />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div className="slider-container">
          <Slider {...bainer_slider}>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/boys-group.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/girls-group.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/girls-stdy.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/robots-repear.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/robots.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/work-palec.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/networking.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/robots-image.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/robots-creates.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-ai.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-ai.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-cyber-security.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-elec-com.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/Civil-Engineering.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-info-tech.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-ai-data.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-mach.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-elec.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
          </Slider>
        </div>
        <div className="slider-container">
          <Slider {...bainer_slider}>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-info-tech.webp" style={{ height: '215px' }} loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/girls-stdy.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-elec-com.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/robots.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-ai.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/Civil-Engineering.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/boys-group.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-elec.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/networking.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-ai-data.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/robots-image.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/girls-group.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/robots-creates.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/work-palec.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/robots-repear.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-mach.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-cyber-security.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>

          </Slider>
        </div>
        <div className="slider-container">
          <Slider {...bainer_slider1}>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/robots.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-mach.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/girls-group.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/Civil-Engineering.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/networking.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-elec-com.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-ai-data.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/robots-repear.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/boys-group.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-info-tech.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/robots-creates.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/work-palec.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/robots-image.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-ai.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/girls-stdy.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-cyber-security.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-elec.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
          </Slider>
        </div>
        <div className="slider-container">
          <Slider {...bainer_slider}>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-ai-data.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/robots-image.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-elec-com.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/girls-stdy.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-ai.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-info-tech.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/robots.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/work-palec.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/Civil-Engineering.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/robots-creates.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-elec.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/boys-group.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/girls-group.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/robots-repear.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-cyber-security.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/networking.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
            <div className='px-1 bainer_slider_container'>
              <img className='img-fluid w-100 rounded' src="/images/btech-mach.webp" loading='lazy' alt="B.Tech in Computer Science Engineering Student" />
            </div>
          </Slider>
        </div>
      </div>
      <div ref={formRef} className='form_parent d-lg-none d-block px-3 my-4'>
        <Admission />
      </div>
      {/* Why Choose Arya Section start */}
      <WhyChooseArya />
      {/* Why Choose Arya Section end */}

      {/* Launchpad Career Section start */}
      <section className="container-fluid py-lg-5 py-4" style={{
        background: "linear-gradient(180deg, #FFFFFF 0%, #F6F6F6 100%)"
      }}>
        <div className="container border p-lg-4 p-2 rounded-4" style={{ background: "#FFFFFF" }}>
          <div className="d-lg-none d-block">
            <h2 className='section_heading'>Boost Your Career with <span> Arya College Jaipur</span></h2>
            <p className="section_para" >Get mentored at one of the best engineering colleges with top placements across industries.</p>
          </div>
          <div className="row align-items-stretch gy-4 flex-column flex-md-row">
            <div className="col-lg-6" style={{ maxHeight: '100vh' }}>
              <img className='w-100 h-100 rounded-4' src="/images/Placements at arya-Img.webp" alt="career success stories" />
            </div>
            <div className="col-lg-6 ps-lg-4">
              <div className="row">
                <div className="col-lg-9">
                  <div className=''>
                    <div className="d-lg-block d-none">
                      <h2 className='section_heading text-start mt-lg-4 mt-3'><span> Your Launchpad to a
                        Rewarding Career</span></h2>
                      <p className="section_para text-start mb-4" style={{ fontSize: '14px' }}>Arya College Jaipur has a stellar record of attracting prestigious recruiters from around the globe. Our academic excellence and cutting-edge research attracts top-notch employers from various industries, ensuring a bright future for our graduates.</p>
                    </div>

                  </div>


                </div>
                <div className="col-lg-3"></div>
              </div>

              <div >
                <div className="d-md-flex align-items-center justify-content-between d-block g-3">
                  <div className='px-3 me-md-3 py-3 d-flex align-items-center justify-content-center' style={{ border: '1px solid #F3E1E1', borderRadius: '14px' }}>

                    <p className='pb-2 mb-0 fs-2 fw-bold me-2' style={{ color: '#E31E24' }}>70+</p>
                    <p className='pb-2 mb-0 '>Companies Brought to Campus</p>
                  </div>
                  <div className='px-3 mt-3 mt-md-0 me-md-3 py-3 d-flex align-items-center justify-content-center' style={{ border: '1px solid #F3E1E1', borderRadius: '14px' }}>
                    <p className='pb-2 mb-0 fs-2 fw-bold me-2' style={{ color: '#E31E24' }}>800+</p>
                    <p className='pb-2 mb-0 '>Offers Generated Across College</p>
                  </div>

                </div>
              </div>

              <div>
                <div className="slider-container pt-2 pe-lg-4 pe-0">
                  {/* <Slider {...fastTrackSlider}>
                    <div className="w-100">
                      <img className="img-fluid" width="150" src="/images/amazon color.svg" alt="" />
                    </div>
                    <div className="w-100">
                      <img className="img-fluid" width="150" src="/images/tcs.svg" alt="" />
                    </div>
                    <div className="w-100">
                      <img className="img-fluid" width="150" src="/images/google.svg" alt="" />
                    </div>
                    <div className="w-100">
                      <img className="img-fluid" width="150" src="/images/jp" alt="" />
                    </div>
                    <div className="w-100">
                      <img className="img-fluid" width="150" src="/images/microsoft.svg" alt="" />
                    </div>

                    <div className="w-100">
                      <img className="img-fluid" width="150" src="/images/amazon color.svg" alt="" />
                    </div>
                    <div className="w-100">
                      <img className="img-fluid" width="150" src="/images/tcs.svg" alt="" />
                    </div>
                    <div className="w-100">
                      <img className="img-fluid" width="150" src="/images/google.svg" alt="" />
                    </div>
                    <div className="w-100">
                      <img className="img-fluid" width="150" src="/images/jp" alt="" />
                    </div>
                    <div className="w-100">
                      <img className="img-fluid" width="150" src="/images/microsoft.svg" alt="" />
                    </div>

                    <div className="w-100">
                      <img className="img-fluid" width="150" src="/images/amazon color.svg" alt="" />
                    </div>
                    <div className="w-100">
                      <img className="img-fluid" width="150" src="/images/tcs.svg" alt="" />
                    </div>

                  </Slider> */}

                  <div className="logo-marquee">
                    <div className="logo-track">

                      <img src="/images/tcs.svg" alt="" />
                      <img src="/images/google.svg" alt="" />
                      <img src="/images/microsoft.svg" alt="" />
                      <img src="/images/amazon color.svg" alt="" />
                      <img src="/images/jp.svg" alt="" />

                      {/* duplicate for smooth loop */}
                      <img src="/images/tcs.svg" alt="" />
                      <img src="/images/google.svg" alt="" />
                      <img src="/images/microsoft.svg" alt="" />
                      <img src="/images/amazon color.svg" alt="" />
                      <img src="/images/jp.svg" alt="" />

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section >
      {/* Growth Section start  */}
      <GrowthSection openModal={openModal} />
      {/* Undergraduate Programs   */}
      <UndergraduatePrograms openModal={openModal} />



      <section className="container-fluid px-0 red_bg_section px-0 position-relative">
        {/* Top Curve */}
        <div className='d-lg-flex d-none'
          style={{
            position: "absolute",
            top: "-56px",
            left: 0,
            width: "100%",
            height: "120px",
            background: "#eeeaeb",
            borderBottomLeftRadius: "50% 100%",
            borderBottomRightRadius: "50% 100%",
            zIndex: 2
          }}
        ></div>
        <div className="container h-100">

          <div className="row align-items-center h-100">
            <div className="col-lg-3"></div>
            <div className="col-lg-6 text-center">
              <div className='py-lg-5'>

                <h2 className='cta_section_header'>Jaipur’s Top Engineering College</h2>
                <p className='cta_para'>Arya College offers 100% placement assistance through well-structured training sessions, mock interview practice, and active corporate connect programs to help every student land the right job.</p>

                {/* CTA Box */}
                <div
                  className="d-inline-flex align-items-center mt-4 px-3 py-2"
                  style={{
                    background: "rgba(255,255,255,0.15)",
                    borderRadius: "40px",
                    backdropFilter: "blur(5px)"
                  }}
                >
                  <span style={{ color: "#fff", marginRight: "15px" }}>
                    Need guidance on REAP Counseling 2026 ?
                  </span>

                  <button onClick={() => openModal("Apply Now")}
                    style={{
                      background: "#fff",
                      color: "#b40103",
                      border: "none",
                      borderRadius: "30px",
                      padding: "8px 20px",
                      fontWeight: "600"
                    }}
                  >
                    Request a callback ↗
                  </button>
                </div>

              </div>
            </div>
            <div className="col-lg-3"></div>
          </div>
        </div>
      </section>
      {/* Pride Excellence Section start */}
      <PrideExcellence openModal={openModal} />
      {/* Industrial Alliances section  */}
      <IndustrialAlliances />
      {/* Footer Section  */}
      <Footer openModal={openModal} />
    </>
  );
}

export default App;
